import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Location } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { AppSettings } from 'src/app/app-settings';
import { InfoCardComponent } from 'src/app/components/shared/info-card/info-card.component';
import { CropperImageComponent } from 'src/app/components/bloques/cropper-image/cropper-image.component';
import { PlacesService } from 'src/app/services/places.service';
import { UpdateVenueComponent } from '../../update-venue/update-venue.component';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-info-venue',
  templateUrl: './info-venue.component.html',
  styleUrls: ['./info-venue.component.scss'],
})
export class InfoVenueComponent {
  @Input() venue!: any;
  urlImages: string = AppSettings.MEDIA_URI + '/spaces/';
  imgControl: FormControl = new FormControl(null);
  changedImg: boolean = false;

  business = JSON.parse(localStorage.getItem('business') || '{}');
  isSuperAdmin: boolean = false;

  membershipTitle: string = 'Amigos de la casa';
  subscriptionText: string =
    'Subscribete a nuestro plan y disfruta de los beneficios que tenemos para ti';

  constructor(
    private placeService: PlacesService,
    private dialog: MatDialog,
    private router: Router,
    public location: Location,
    private auth: AuthenticationService,
  ) {
    this.isSuperAdmin = this.auth.isSuperAdmin();
  }

  ngAfterViewInit(): void {
    let url = location.pathname.split('/');
    let idVenue = +url[url.length - 1];
    this.getVenue(idVenue);
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        var url = event.url;
        let idVenue = +url[url.length - 1];
        this.getVenue(idVenue);
      }
    });
  }

  goToMap() {
    let url = location.pathname.split('/');
    let idVenue = url[url.length - 1];
    this.router.navigate(['/panel-control/config/venues/create-map', idVenue]);
  }

  getVenue(idVenue: any) {
    if (idVenue) {
      this.placeService.getPlaceById(idVenue).subscribe({
        next: (res: any) => {
          this.venue = res.data;
          if (this.venue?.img_url) {
            const urlImage = this.urlImages + this.venue.img_url;
            this.imgControl.setValue(urlImage);
          }
          this.membershipTitle = 'Subscriptor de ' + this.venue.name;
          this.subscriptionText =
            'Conviértete en subscriptor de ' +
            this.venue.name +
            ' y disfruta de beneficios exclusivos.';
        },
      });
    }
  }

  onFileChange(event: any) {
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];

      // Validar que sea una imagen
      if (!file.type.match('image.*')) {
        this.openInfoCard('Solo se permite utilizar imágenes', false, true);
        event.target.value = '';
        return;
      }

      // Validar tamaño máximo de 10 MB (10485760 bytes)
      const maxSize = 10 * 1024 * 1024; // 10 MB
      if (file.size > maxSize) {
        this.openInfoCard(
          'La imagen no puede ocupar <br> más de 10 MB.',
          false,
          true,
        );
        event.target.value = '';
        return;
      }

      const dialogRef = this.dialog.open(CropperImageComponent, {
        panelClass: 'info-dialog',
        disableClose: true,
        data: event,
      });

      dialogRef.afterClosed().subscribe((result) => {
        event.target.value = '';
        if (result) {
          this.imgControl.setValue(result.pathUrl);
          this.changedImg = true;
          // Guardar la imagen recortada
          this.placeService
            .updateImage(this.venue.id, { file: result.object.base64 })
            .subscribe({
              next: (res) => {
                this.openInfoCard(
                  'La imagen se ha actualizado correctamente',
                  false,
                  false,
                );
                this.changedImg = false;
              },
              error: (err) => {
                this.openInfoCard(
                  '¡Vaya! Ha ocurrido un error al intentar actualizar la imagen',
                  true,
                  false,
                );
                if (this.venue.img_url) {
                  this.imgControl.setValue(this.venue.img_url);
                }
              },
            });
        }
      });
    }
    if (!event.target.files) {
      if (this.venue.img_url) {
        this.imgControl.setValue(this.venue.img_url);
      }
    }
  }

  updateFile() {
    this.placeService
      .updateImage(this.venue.id, { file: this.imgControl.value })
      .subscribe({
        next: (res) => {
          this.openInfoCard(
            'La imagen se ha actualizado correctamente',
            false,
            false,
          );
          this.changedImg = false;
        },
        error: (err) => {
          this.openInfoCard(
            '¡Vaya! Ha ocurrido un error al intentar actualizar la imagen',
            true,
            false,
          );
        },
      });
  }

  openInfoCard(
    msg: string,
    disabledClose: boolean = false,
    icon: boolean = true,
    success: boolean = false,
  ) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: ['info-dialog'],
      disableClose: disabledClose,
      data: {
        icon: icon,
        text: msg,
        btnCancel: false,
        success: success,
      },
    });
  }

  openUpdateVenue(valueToChange: any, nameValue: string) {
    if (valueToChange === 'slug') {
      this.confirmSlugEdit().then((confirmed) => {
        if (confirmed) {
          this.openUpdateVenueDialog(valueToChange, nameValue);
        }
      });
      return;
    }

    this.openUpdateVenueDialog(valueToChange, nameValue);
  }

  private confirmSlugEdit(): Promise<boolean> {
    return new Promise((resolve) => {
      const dialogRef = this.dialog.open(InfoCardComponent, {
        panelClass: 'info-dialog',
        disableClose: true,
        data: {
          icon: true,
          text: '¿Estás seguro de que quieres cambiar la URL personalizada del espacio? Los enlaces que se hayan compartido con la URL ya no serán válidos.',
          btnCancel: true,
          textButton: 'Sí',
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        resolve(!!result);
      });
    });
  }

  private openUpdateVenueDialog(valueToChange: any, nameValue: string) {
    const dialogRef = this.dialog.open(UpdateVenueComponent, {
      panelClass: 'info-dialog',
      data: {
        valueChange: valueToChange,
        name: nameValue,
        value: this.venue,
      },
    });
    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res?.status == 'changed') {
          this.venue = res.venue;
          this.openInfoCard(
            'Los cambios se han guardado correctamente',
            false,
            false,
            true,
          );
        }
        if (res?.status == 'error') {
          const msg = res.msg || 'El slug ya está en uso';
          this.openInfoCard(msg);
        }
      },
    });
  }

  saveSubscribersOptions() {
    const dialogRef = this.dialog.open(UpdateVenueComponent, {
      panelClass: 'info-dialog',
      data: {
        value: this.venue,
      },
    });
    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res == 'changed') {
          this.openInfoCard(
            'Los cambios se han guardado correctamente',
            false,
            false,
            true,
          );
        }
        if (res == 'error') {
          this.openInfoCard('¡Vaya! Ha ocurrido un error.');
        }
      },
    });
  }

  updateAllowSubscribers() {
    const payload = {
      allow_subscription: this.venue.allow_subscription,
      membership_title: this.venue.membership_title || this.membershipTitle,
      subscription_text: this.venue.subscription_text || this.subscriptionText,
    };

    this.placeService.updateVenue(this.venue.id, payload).subscribe({
      next: (res) => {
        this.openInfoCard(
          'Los cambios se han guardado correctamente',
          false,
          false,
          true,
        );
        if (res?.data) {
          this.venue.allow_subscription = res.data.allow_subscription;
          this.venue.membership_title = res.data.membership_title;
          this.venue.subscription_text = res.data.subscription_text;
        }
      },
      error: (err) => {
        this.openInfoCard('¡Vaya! Ha ocurrido un error.');
        this.venue.allow_subscription = !this.venue.allow_subscription;
      },
    });
  }

  getVenuePublicUrl(): string {
    const venueSlug = (this.venue?.slug || '').trim();
    return `${window.location.origin}/venue/${venueSlug}`;
  }

  copyVenueUrl(): void {
    navigator.clipboard.writeText(this.getVenuePublicUrl());
    this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: false,
        text: '¡Enlace copiado al portapapeles!',
        btnCancel: false
      }
    });
  }
}
